export default __webpack_public_path__ + "static/media/Craggy_Kitchen1.1742a62c.jpg";